
export default {
  props: {
    isFilled: {
      type: Boolean,
      default: false,
    },
  },
}
